import { useQuery } from '@tanstack/react-query';
import { flags } from '../constants/flags';
import { apiFetch, authHeaders } from './apiHelpers';

export function useLanguages() {
    return useQuery<string[], Error>({
        queryKey: ['languages'],
        queryFn: () => apiFetch<string[]>('api/Language', { method: 'GET', headers: authHeaders() }),
        staleTime: Infinity
    });
}

export function useLanguagesMatch(): boolean {
    const { data: languageCodes } = useLanguages();
    if (!languageCodes || languageCodes.length === 0) return true;
    const clientCodes = flags.map(f => f.cultureCode);
    const intersection = languageCodes.filter(l => clientCodes.includes(l));
    return intersection.length === clientCodes.length && intersection.length === languageCodes.length;
}
